/**
 * Reactor config shared by an Era 1 module's pre-placed `NodeDef` and its bound
 * card (spec 0068 "Single source of truth"). A leaf file on purpose: `cards.ts`
 * cannot import the module files (they import `ALL_CARDS`), and the two sides
 * must never be able to drift apart.
 *
 * Every number is a PLACEHOLDER (spec 0037) needing playtest; the comments on
 * each say what it was chosen to do.
 */

/** Furnace-lined: the melt makes 2 heat a tick at k = 2, which a lone 1 kW jacket holds under this until the quota lands. */
export const MELT_CRITICAL_TEMP = 12;
/** Heavy-Duty Mixer's own receiving buffer (card-mixer-heavy); the Surge Drum widens it to hold a batch plus the packet on its way out. */
export const MELT_BUFFER = 4;
/** The engine default (NODE_DEFAULTS.criticalTemp): one heat a firing reaches it on the fourth tick and explodes on the fifth. */
export const COLOUR_CRITICAL_TEMP = 4;

/** The smelter carries the Heavy-Duty Mixer's own stats: it holds three arrivals plus last tick's product. */
export const MT_SMELTER_CRITICAL_TEMP = 8;
export const MT_SMELTER_BUFFER = 4;
export const MT_CEMENT_BUFFER = 4;

/** Two heat is one below the catalogue reactor's four and, uncooled, is reached on the second firing. */
export const PF_STEEP_CRITICAL_TEMP = 2;
/** Four packets fit because the previous product is still in the buffer when the next three arrive. */
export const PF_STEEP_BUFFER = 4;
